import {
	Add,
	Archive,
	AssistantDirection,
	Email,
	KeyboardArrowLeft,
	LocationCity,
	LocationOn,
	MarkAsUnread,
	Numbers,
	Phone,
	RestoreFromTrash,
} from '@mui/icons-material';
import LoadingButton from '@mui/lab/LoadingButton';
import { Button, Divider, Grid, IconButton, Paper, Stack, Tab, Tabs, Typography } from '@mui/material';
import { Box } from '@mui/system';
import DioceseTable from 'Components/AdminPanel/Diocese/DioceseTable';
import { useGlobalStyles } from 'Components/Common/global/global';
import {
	ColumnType,
	dioceseHead,
	donationsTableHead,
	hcaOrdersHead,
	schoolHead,
} from 'Components/Common/Tables/TableHeaders';
import { FormTextField } from 'Components/Common/TextField';
import { ContentSkeleton } from 'Components/Deposits/CreateEditDepositWithDonations/Content';
import DonationsTable from 'Components/Donations/DonationsTable';
import { styles } from 'Components/Donors/DonorInfo/DonorInfo.style';
import OrderList from 'Components/HCA/Orders/OrdersList';
import ProvinceAutocomplete from 'Components/Province';
import FilterListButton from 'Components/Reusable/FilterList/FilterList';
import useDebounce from 'Components/Reusable/hooks/debounce';
import AdvancedSearchModal, {
	Field as AdvanceSearchField,
} from 'Components/Reusable/Modals/AdvancedSearch/AdvancedSearchModal';
import { searchDioceseField } from 'Components/Reusable/Modals/AdvancedSearch/Mock';
import ConfirmationModal from 'Components/Reusable/Modals/ConfirmationModal';
import TrimTables from 'Components/Reusable/TrimTables/TrimTables';
import { GlobalContexts } from 'contexts/GlobalContext';
import { Diocese, DioceseData, DonationsData, FilterPayload, OrderType, SchoolBoard, SchoolData, StateType } from 'contexts/intialstates/Types';
import { Field, Form, Formik, FormikProps } from 'formik';
import useDioceseActions from 'hooks/useDioceseActions';
import useDonationActions from 'hooks/useDonationActions';
import useSchoolActions from 'hooks/useSchoolActions';
import useSchoolBoardActions from 'hooks/useSchoolBoardActions';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import * as yup from 'yup';
import SchoolTable from '../School/SchoolTable';
import DioceseField from './DioceseField';
import NotesSchoolBoard from './NotesSchoolBoard';

export interface SchoolBoardValues {
	code: string;
	name: string;
	director: string;
	streetline1: string;
	streetline2: string;
	city: string;
	province: string;
	provinceId?: number;
	postalCode: string;
	phone: string;
	fax: string;
	email: string;
	dioceseId?: number;
	country: string;
	diocese?: {
		id?: number;
		dioceseName?: string;
	};
}

interface TabPanelProps {
	children?: React.ReactNode;
	index: number;
	value: number;
}

function TabPanel(props: TabPanelProps) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			style={{ marginBottom: '2rem' }}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && <Box sx={{ p: 3 }}>{children}</Box>}
		</div>
	);
}

function a11yProps(index: number) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	};
}

const CreateEditSchoolBoard = () => {
	const global = useGlobalStyles();
	const navigate = useNavigate();
	const { id } = useParams();
	const { getAllDiocese } = useDioceseActions();
	const { createSchoolBoard, updateSchoolBoard, getSchoolBoardsByID, restoreSchoolBoard, deleteSchoolBoard } =
		useSchoolBoardActions();
	const [loading, setLoading] = useState<boolean>(false);
	const [isDelete, setIsDelete] = useState(false);
	const [saveLoading, setSaveLoading] = useState(false);
	const [value, setValue] = React.useState(0);
	const [trimList, setTrimList] = React.useState<ColumnType[]>([]);
	const { getSchools } = useSchoolActions();
	const { getDonationsBySchoolBoard } = useDonationActions();
	const [page, setPage] = React.useState(0);
	const [pageSize, setPageSize] = React.useState(10);
	const [orderType, setOrderType] = React.useState<OrderType>('asc');
	const [label, setLabel] = React.useState<string>('');
	const [orderBy, setOderBy] = React.useState<string>('');
	const [reload, setReload] = React.useState(false);
	const [filterPayload, setFilterPayload] = React.useState<Array<FilterPayload>>([]);
	const { getDioceses, getDioceseBySearch } = useDioceseActions();
	const [dioceses, setDioceses, ,] = React.useState<StateType<DioceseData>>({
		data: null,
		error: null,
		loading: false,
	});
	const [schools, setSchools] = React.useState<StateType<SchoolData>>({
		data: null,
		error: null,
		loading: false,
	});
	const [allDonationsBySchoolBoard, setAllDonationsBySchoolBoard] = React.useState<StateType<DonationsData>>({
		data: null,
		error: null,
		loading: false,
	});
	const [searchDiocese, setSearchDiocese] = React.useState<StateType<Diocese[]>>({
		data: null,
		error: null,
		loading: false,
	});
	const { setSimpleErrorSnack } = React.useContext(GlobalContexts);
	const [open, setOpen] = React.useState<any>({ state: false, type: '' });
	const [searchFieldsDiocese, setSearchFieldsDiocese] = useState<AdvanceSearchField[]>(searchDioceseField);
	const [visibleSearchDiocese, setVisibleSearchDiocese] = useState(false);
	const [visibleSearch, setVisibleSearch] = useState(false);
	const [dioceseSearchTerm, setDioceseSearchTerm] = useState('');
	const dioceseDebouncedSearchTerm = useDebounce(dioceseSearchTerm, 1000);
	const [initial, setInitial] = useState<SchoolBoardValues>({
		code: '',
		name: '',
		director: '',
		streetline1: '',
		streetline2: '',
		city: '',
		province: '',
		postalCode: '',
		country: '',
		phone: '',
		email: '',
		fax: '',
		dioceseId: undefined,
	});
	const [allDioceses, setAllDioceses] = React.useState<StateType<DioceseData>>({
		data: null,
		error: null,
		loading: false,
	});
	const [schoolBoard, setSchoolBoard] = React.useState<StateType<SchoolBoard>>({
		data: null,
		error: null,
		loading: false,
	});

	const formikRef = useRef<FormikProps<SchoolBoardValues>>(null);
	
	const handleVisibleSearchDiocese = () => {
		setVisibleSearchDiocese(!visibleSearchDiocese);
	};
	const handleSearchDiocese = () => {
		const payload: any = searchFieldsDiocese.map(({ key, value }) => {
			if (value) {
				return {
					field: key,
					query: key !== 'phone' ? value : null,
					value: key === 'phone' ? [value] : null,
					from: null,
					to: null,
				};
			}
		});

		setFilterPayload(payload.filter(Boolean));
	};
	useEffect(() => {
		getDioceses({
			archive: '&Filters=field=archived;value=false',
			setDioceses,
			dioceses,
			pageSize,
			page,
			orderBy,
			filterPayload,
		});
	}, [page, pageSize, orderBy, reload]);

	useEffect(() => {
		if (!id) return;
		getSchoolBoardsByID({ setSchoolBoard, schoolBoard, id: parseInt(id) });
	}, [id, value, reload]);

	React.useEffect(() => {
		if (id && value == 1)
			getDonationsBySchoolBoard({
				page,
				pageSize,
				schoolBoardId: parseInt(id),
				allDonationsBySchoolBoard,
				setAllDonationsBySchoolBoard,
				orderBy,
				filterPayload,
			});
		if (id && value == 2)
			getSchools({
				archive: '&Filters=field=archived;value=false',
				schools,
				setSchools,
				schoolBoardId: parseInt(id),
				page,
				pageSize,
				orderBy,
			});
	}, [page, pageSize, orderBy, id, value]);

	useEffect(() => {
		if (!schoolBoard?.data) return;
		const {
			code,
			name,
			director,
			streetline1,
			streetline2,
			city,
			province,
			postalCode,
			country,
			phone,
			fax,
			email,
			diocese,
		} = schoolBoard?.data;
		setInitial({
			code,
			name,
			director,
			streetline1,
			streetline2,
			city,
			province: province?.provinceName ?? '',
			provinceId: province?.id,
			postalCode,
			country,
			phone,
			fax,
			email,
			dioceseId: diocese?.id,
			diocese: { id: diocese?.id, dioceseName: diocese?.dioceseName },
		});
	}, [schoolBoard]);

	useEffect(() => {
		getAllDiocese({ setAllDioceses, allDioceses });
	}, []);

	const handleSubmit = async (values: SchoolBoardValues) => {
		if (!values.diocese?.id) {
			return setSimpleErrorSnack({ show: true, severity: 'error', message: 'Diocese is required' });
		}
		let isSucess;
		setLoading(true);

		if (id) {
			isSucess = await updateSchoolBoard(
				{
					code: values.code,
					name: values.name?.trim(),
					director: values.director?.trim(),
					streetline1: values.streetline1?.trim(),
					streetline2: values.streetline2?.trim(),
					city: values.city?.trim(),
					province: values.province?.trim(),
					provinceId: values.provinceId,
					postalCode: values.postalCode?.trim(),
					phone: values.phone?.trim(),
					fax: values.fax?.trim(),
					email: values.email?.trim(),
					country: values.country?.trim(),
					dioceseId: values.diocese?.id,
				},
				parseInt(id),
			);
		} else {
			isSucess = await createSchoolBoard({
				code: values.code,
				name: values.name?.trim(),
				director: values.director?.trim(),
				streetline1: values.streetline1?.trim(),
				streetline2: values.streetline2?.trim(),
				city: values.city?.trim(),
				province: values.province?.trim(),
				provinceId: values.provinceId,
				postalCode: values.postalCode?.trim(),
				phone: values.phone?.trim(),
				fax: values.fax?.trim(),
				email: values.email?.trim(),
				country: values.country?.trim(),
				dioceseId: values.diocese?.id,
			});
		}
		setLoading(false);
		if (isSucess) {
			navigate('/hca/school-boards');
		}
	};

	const validateSchoolBoard = yup.object().shape({
		name: yup.string().trim().required('Name is required'),
		email: yup.string().trim().email('Invalid Email'),
		phone: yup.number().typeError('Invalid Phone number'),
	});

	const handleCloseDelete = () => {
		setIsDelete(false);
	};

	const handleDelete = async () => {
		if (!id) return;
		if (schoolBoard.data?.archived) {
			setSaveLoading(true);
			const isSucess = await restoreSchoolBoard(parseInt(id));
			setSaveLoading(false);
			handleCloseDelete();
			if (isSucess) {
				setReload(!reload);
			}
			return;
		}
		setSaveLoading(true);
		const isSucess = await deleteSchoolBoard(parseInt(id));
		setSaveLoading(false);
		handleCloseDelete();
		if (isSucess) {
			navigate('/hca/school-boards');
		}
	};

	const handleChange = (event: React.SyntheticEvent, newValue: number) => {
		setValue(newValue);
	};

	const currentHead = () => {
		if (value === 1) return { value: donationsTableHead, label: 'donationsTableHead' };
		if (value === 2) return { value: schoolHead, label: 'schoolHead' };
		if (value === 3) return { value: hcaOrdersHead, label: 'hcaOrdersHead' };
	};

	useEffect(() => {
		if (!dioceseDebouncedSearchTerm) return;
		getDioceseBySearch({ searchDiocese, setSearchDiocese, searchTerm: dioceseSearchTerm });
	}, [dioceseDebouncedSearchTerm]);

	const handleSelectRowDiocese = (row: any) => {
		const temp = { ...initial, dioceses: { id: parseInt(row?.id), dioceseName: row?.dioceseName } };
		setInitial(temp as any);
		handleVisibleSearchDiocese();
	};

	const handleSave  = async () => {
		const errors = await formikRef.current?.validateForm();

		formikRef.current?.setTouched(
			Object.keys(errors || {}).reduce((acc, key) => ({ ...acc, [key]: true }), {}),
			true
		);

		if (errors && Object.keys(errors).length > 0) {
			setSimpleErrorSnack({
				message: `Please fill all the required fields.`,
				severity: 'error',
				show: true,
			});
		} else {
			formikRef.current?.submitForm()
		}
	}


	return (
		<>
			<Box>
				{schoolBoard?.loading ? (
					<ContentSkeleton />
				) : (
					<Formik
						enableReinitialize
						onSubmit={handleSubmit}
						validationSchema={validateSchoolBoard}
						initialValues={initial}
						innerRef={formikRef}
					>
						{({ values, setFieldValue, errors, touched }) => (
							<Form noValidate autoComplete="off">
								<>
									<Stack
										direction={{ xs: 'row', sm: 'column' }}
										alignItems={{ xs: 'center', sm: 'initial' }}
										justifyContent={{ xs: 'center', sm: 'initial' }}
										spacing={{ xs: 3, sm: 0 }}
									>
										<Stack
											alignItems={'center'}
											justifyContent={'center'}
											sx={{ display: { xs: 'flex', sm: 'none' }, background: '#fff' }}
										>
											<IconButton
												id="demo-customized-button"
												aria-haspopup="true"
												onClick={() => navigate(-1)}
											>
												<KeyboardArrowLeft color="primary" />
											</IconButton>
										</Stack>
										<Stack
											alignItems="center"
											direction={{ xs: 'column', sm: 'row' }}
											justifyContent={'space-between'}
											spacing={1}
										>
											<Stack
												alignItems={'center'}
												direction="row"
												justifyContent={'flex-start'}
												spacing={{ xs: 0, sm: 4 }}
												mb={{ xs: 1, sm: 0 }}
											>
												<Stack
													alignItems={'center'}
													justifyContent={'center'}
													sx={{ display: { xs: 'none', sm: 'flex' }, background: '#fff' }}
												>
													<IconButton
														id="demo-customized-button"
														aria-haspopup="true"
														onClick={() => navigate(-1)}
													>
														<KeyboardArrowLeft color="primary" />
													</IconButton>
												</Stack>
												<Stack direction="column" spacing={1}>
													<Stack direction="column">
														<Box
															sx={{
																fontSize: '32px',
																fontWeight: 700,
																color: 'var(--mainColor)',
																wordWrap: 'normal',
															}}
														>
															School Board
														</Box>
														{id && <span>School Board Code: {schoolBoard.data?.code}</span>}
													</Stack>
													{id && (
														<Button sx={styles.statusBtn} disableElevation disableRipple variant="outlined">
															{schoolBoard.data?.archived ? 'Archived' : 'Active'}
														</Button>
													)}
												</Stack>
											</Stack>
											<Stack
												direction={{ xs: 'column', md: 'row' }}
												justifyContent={'flex-end'}
												flexWrap="wrap"
												alignItems={{ md: 'center' }}
												gap={1}
											>
												{value !== 0 && value !== 4 && (
													<TrimTables
														name={currentHead()?.label as any}
														list={currentHead()?.value as any}
														trimList={trimList}
														setTrimList={setTrimList}
													/>
												)}

												{id && (
													<Button
														sx={{ textTransform: 'none', background: '#fff' }}
														startIcon={schoolBoard.data?.archived ? <RestoreFromTrash /> : <Archive />}
														variant="outlined"
														onClick={() => setIsDelete(true)}
													>
														{schoolBoard.data?.archived ? 'Unarchive' : 'Archive'}
													</Button>
												)}
												<LoadingButton
													sx={{ textTransform: 'capitalize' }}
													variant="contained"
													disableElevation
													startIcon={<Add />}
													onClick={() => handleSave()}
													loading={loading}
													loadingPosition="start"
												>
													Save
												</LoadingButton>
												<FilterListButton
													reload={reload}
													setIsReload={setReload}
													setPage={setPage}
													page={page}
													setFilterPayload={setFilterPayload}
													filterPayload={filterPayload}
												/>
											</Stack>
										</Stack>
									</Stack>

									<Paper sx={{ width: '100%', p: 3, minHeight: '80vh', mt: 5 }}>
										<Box sx={{ borderBottom: '1px solid #ABAEB0' }}>
											<Tabs
												value={value}
												variant="fullWidth"
												onChange={handleChange}
												aria-label="basic tabs example"
											>
												<Tab
													sx={{ textTransform: 'capitalize', color: '#1976D2' }}
													label="Details"
													{...a11yProps(0)}
												/>
												<Tab
													sx={{ textTransform: 'capitalize', color: '#1976D2' }}
													label="Donations"
													{...a11yProps(1)}
													disabled={typeof id === 'undefined'}
												/>
												<Tab
													sx={{ textTransform: 'capitalize', color: '#1976D2' }}
													label="Schools"
													{...a11yProps(2)}
													disabled={typeof id === 'undefined'}
												/>
												<Tab
													sx={{ textTransform: 'capitalize', color: '#1976D2' }}
													label="HCA Orders"
													{...a11yProps(3)}
													disabled={typeof id === 'undefined'}
												/>
												<Tab
													sx={{ textTransform: 'capitalize', color: '#1976D2' }}
													label="Notes"
													{...a11yProps(4)}
													disabled={typeof id === 'undefined'}
												/>
											</Tabs>
										</Box>
										<TabPanel value={value} index={0}>
											<Box>
												<Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 4 }} mt={2}>
													<Grid item xs={12} md={4} sm={6} mb={3} pr={{ lg: 5, md: 0 }}>
														<Grid container>
															<Grid item>
																<Numbers className={global.formLabelIcon} />
															</Grid>
															<Grid item>
																<Typography variant="body2" className={global.formLabelText}>
																	Code
																</Typography>
															</Grid>
														</Grid>
														<Stack direction="column">
															<Field
																name="code"
																variant="outlined"
																placeholder="Code"
																component={FormTextField}
																disabled={true}
															/>
															<span style={{ color: 'var(--mainColor)', fontSize: 12, marginTop: 2 }}>
																This is an auto-generated code
															</span>
														</Stack>
													</Grid>
													<Grid item xs={12} md={4} sm={6} mb={3} pr={{ lg: 5, md: 0 }}>
														<Grid container>
															<Grid item>
																<Add className={global.formLabelIcon} />
															</Grid>
															<Grid item>
																<Typography variant="body2" className={global.formLabelText}>
																	Name
																</Typography>
															</Grid>
														</Grid>
														<Field
															name="name"
															variant="outlined"
															placeholder="Name"
															component={FormTextField}
														/>
													</Grid>
													<Grid item xs={12} md={4} sm={6} mb={3} pr={{ lg: 5, md: 0 }}>
														<Grid container>
															<Grid item>
																<Numbers className={global.formLabelIcon} />
															</Grid>
															<Grid item>
																<Typography variant="body2" className={global.formLabelText}>
																	Director
																</Typography>
															</Grid>
														</Grid>
														<Field
															name="director"
															variant="outlined"
															placeholder="Director"
															component={FormTextField}
														/>
													</Grid>

													<Grid item xs={12} md={4} sm={6} mb={3} pr={{ lg: 5, md: 0 }}>
														<Grid container>
															<Grid item>
																<Add className={global.formLabelIcon} />
															</Grid>
															<Grid item>
																<Typography variant="body2" className={global.formLabelText}>
																	Diocese
																</Typography>
															</Grid>
														</Grid>
														<DioceseField values={values} setFieldValue={setFieldValue} />
													</Grid>
												</Grid>
												<Typography sx={{ fontSize: 14, fontWeight: 600, mt: 2 }}>Contact Details</Typography>
												<Divider />
												<Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 4 }} mt={2}>
													<Grid item xs={12} md={4} sm={6} mb={3} pr={{ lg: 5, md: 0 }}>
														<Grid container>
															<Grid item>
																<Phone className={global.formLabelIcon} />
															</Grid>
															<Grid item>
																<Typography variant="body2" className={global.formLabelText}>
																	Phone
																</Typography>
															</Grid>
														</Grid>
														<Field
															name="phone"
															variant="outlined"
															placeholder="Phone"
															component={FormTextField}
														/>
													</Grid>
													<Grid item xs={12} md={4} sm={6} mb={3} pr={{ lg: 5, md: 0 }}>
														<Grid container>
															<Grid item>
																<Email className={global.formLabelIcon} />
															</Grid>
															<Grid item>
																<Typography variant="body2" className={global.formLabelText}>
																	Email
																</Typography>
															</Grid>
														</Grid>
														<Field
															name="email"
															variant="outlined"
															placeholder="Email"
															component={FormTextField}
														/>
													</Grid>
													<Grid item xs={12} md={4} sm={6} mb={3} pr={{ lg: 5, md: 0 }}>
														<Grid container>
															<Grid item>
																<Phone className={global.formLabelIcon} />
															</Grid>
															<Grid item>
																<Typography variant="body2" className={global.formLabelText}>
																	Fax
																</Typography>
															</Grid>
														</Grid>
														<Field
															name="fax"
															variant="outlined"
															placeholder="Fax"
															component={FormTextField}
														/>
													</Grid>
												</Grid>

												<Typography sx={{ fontSize: 14, fontWeight: 600, mt: 2 }}>Address Details</Typography>
												<Divider />
												<Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 4 }} mt={2}>
													<Grid item xs={12} md={4} sm={6} mb={3} pr={{ lg: 5, md: 0 }}>
														<Grid container>
															<Grid item>
																<LocationOn className={global.formLabelIcon} />
															</Grid>
															<Grid item>
																<Typography variant="body2" className={global.formLabelText}>
																	Streetline 1
																</Typography>
															</Grid>
														</Grid>
														<Field
															name="streetline1"
															variant="outlined"
															placeholder="Streetline 1"
															component={FormTextField}
														/>
													</Grid>
													<Grid item xs={12} md={4} sm={6} mb={3} pr={{ lg: 5, md: 0 }}>
														<Grid container>
															<Grid item>
																<LocationOn className={global.formLabelIcon} />
															</Grid>
															<Grid item>
																<Typography variant="body2" className={global.formLabelText}>
																	Streetline 2
																</Typography>
															</Grid>
														</Grid>
														<Field
															name="streetline2"
															variant="outlined"
															placeholder="Streetline 2"
															component={FormTextField}
														/>
													</Grid>
													<Grid item xs={12} md={4} sm={6} mb={3} pr={{ lg: 5, md: 0 }}>
														<Grid container>
															<Grid item>
																<LocationCity className={global.formLabelIcon} />
															</Grid>
															<Grid item>
																<Typography variant="body2" className={global.formLabelText}>
																	City
																</Typography>
															</Grid>
														</Grid>
														<Field
															name="city"
															variant="outlined"
															placeholder="City"
															component={FormTextField}
														/>
													</Grid>
													<Grid item xs={12} md={4} sm={6} mb={3} pr={{ lg: 5, md: 0 }}>
														<Grid container>
															<Grid item>
																<AssistantDirection className={global.formLabelIcon} />
															</Grid>
															<Grid item>
																<Typography variant="body2" className={global.formLabelText}>
																	Province
																</Typography>
															</Grid>
														</Grid>
														<ProvinceAutocomplete
															value={initial.province}
															handleChange={(val) => setFieldValue('provinceId', parseInt(val?.id))}
														/>
													</Grid>
													<Grid item xs={12} md={4} sm={6} mb={3} pr={{ lg: 5, md: 0 }}>
														<Grid container>
															<Grid item>
																<MarkAsUnread className={global.formLabelIcon} />
															</Grid>
															<Grid item>
																<Typography variant="body2" className={global.formLabelText}>
																	Postal Code
																</Typography>
															</Grid>
														</Grid>
														<Field
															name="postalCode"
															variant="outlined"
															placeholder="Postal Code"
															component={FormTextField}
														/>
													</Grid>
													<Grid item xs={12} md={4} sm={6} mb={3} pr={{ lg: 5, md: 0 }}>
														<Grid container>
															<Grid item>
																<LocationCity className={global.formLabelIcon} />
															</Grid>
															<Grid item>
																<Typography variant="body2" className={global.formLabelText}>
																	Country
																</Typography>
															</Grid>
														</Grid>
														<Field
															name="country"
															variant="outlined"
															placeholder="Country"
															component={FormTextField}
														/>
													</Grid>
												</Grid>
											</Box>
										</TabPanel>
										<TabPanel value={value} index={1}>
											{id && (
												<DonationsTable
													trimList={trimList}
													setTrimList={setTrimList}
													page={page}
													pageSize={pageSize}
													setPage={setPage}
													setPageSize={setPageSize}
													label={label}
													orderType={orderType}
													setLabel={setLabel}
													setOderBy={setOderBy}
													setOrderType={setOrderType}
													donations={allDonationsBySchoolBoard}
												/>
											)}
										</TabPanel>
										<TabPanel value={value} index={2}>
											{id && (
												<SchoolTable
													trimList={trimList}
													setTrimList={setTrimList}
													page={page}
													pageSize={pageSize}
													setPage={setPage}
													setPageSize={setPageSize}
													label={label}
													orderType={orderType}
													setLabel={setLabel}
													setOderBy={setOderBy}
													setOrderType={setOrderType}
													schools={schools}
												/>
											)}
										</TabPanel>
										<TabPanel value={value} index={3}>
											{id && (
												<OrderList
													setFilterPayload={setFilterPayload}
													filterPayload={filterPayload}
													reload={reload}
													setReload={setReload}
													trimList={trimList}
													setTrimList={setTrimList}
													category={id ? `boardId=${id}&` : 'nil'}
													currentRoute="Board"
													setPage={setPage}
													page={page}
												/>
											)}
										</TabPanel>
										<TabPanel value={value} index={4}>
											{id && <NotesSchoolBoard schoolBoardId={parseInt(id)} />}
										</TabPanel>
									</Paper>
								</>
							</Form>
						)}
					</Formik>
				)}
			</Box>
			{visibleSearchDiocese && (
				<AdvancedSearchModal
					visible={visibleSearchDiocese}
					handleClose={handleVisibleSearchDiocese}
					field={searchFieldsDiocese}
					setField={setSearchFieldsDiocese}
					title={'Search Diocese'}
					handleSearch={handleSearchDiocese}
				>
					<>
						<Stack alignItems={'flex-end'}>
							<TrimTables
								name="dioceseHead"
								list={dioceseHead}
								trimList={trimList}
								setTrimList={setTrimList}
							/>
						</Stack>
						<DioceseTable
							trimList={trimList}
							setTrimList={setTrimList}
							page={page}
							pageSize={pageSize}
							setPage={setPage}
							setPageSize={setPageSize}
							label={label}
							orderType={orderType}
							setLabel={setLabel}
							setOderBy={setOderBy}
							setOrderType={setOrderType}
							dioceses={dioceses}
							hcaOrgList
							open={open}
							setOpen={setOpen}
							handleOpenEdit={handleSelectRowDiocese}
						/>
					</>
				</AdvancedSearchModal>
			)}
			<ConfirmationModal
				handleClose={() => setIsDelete(false)}
				message={
					schoolBoard.data?.archived
						? 'Do you want to unarchive school board?'
						: 'Are you sure you want to delete this school board?'
				}
				open={isDelete}
				handleConfirmation={handleDelete}
				handleCancel={() => setIsDelete(false)}
				loading={saveLoading}
			/>
		</>
	);
};

export default CreateEditSchoolBoard;
